// The ACTUAL Cura mark, measured dot-by-dot from the 512px icon (connected-
// component analysis of chai-icon-burgundy-512.png): one core, an inner ring
// of NINE (~40° apart), an outer halo of EIGHTEEN (~20° apart). The slight
// radius/distance wobble is part of the mark — do not idealise it.
// [cx, cy, r, ring] on a 512×512 canvas. Shared by the login splash
// (proxy.ts splashResponse) and the /login page's BloomMark.
export const CURA_MARK_DOTS: ReadonlyArray<[number, number, number, number]> = [
  [255.5, 255.8, 62.2, 0],
  [331.3, 168.1, 34.0, 1], [179.7, 168.1, 34.0, 1], [255.5, 137.2, 33.5, 1],
  [215.9, 374.3, 33.5, 1], [295.1, 374.3, 33.5, 1], [151.4, 318.5, 33.5, 1],
  [359.6, 318.5, 33.5, 1], [375.4, 239.8, 33.8, 1], [135.6, 239.8, 33.8, 1],
  [96.8, 340.9, 15.8, 2], [414.2, 340.9, 15.8, 2], [143.3, 393.5, 15.8, 2],
  [367.7, 393.5, 15.8, 2], [143.3, 117.9, 15.8, 2], [367.7, 117.9, 15.8, 2],
  [312.3, 79.6, 15.5, 2], [198.7, 79.5, 15.5, 2], [255.5, 65.5, 15.5, 2],
  [255.5, 446.1, 15.5, 2], [96.8, 170.7, 15.5, 2], [414.2, 170.7, 15.5, 2],
  [198.6, 432.0, 15.2, 2], [312.4, 432.0, 15.2, 2], [70.0, 227.4, 15.2, 2],
  [441.0, 227.4, 15.2, 2], [441.0, 284.2, 15.2, 2], [70.0, 284.2, 15.2, 2],
];

/** Bloom-in delay for a dot, staggered by its own angle so the mark opens
 *  like a ripple travelling clockwise. Ring 0 (core) pops immediately. */
export function curaDotDelay(cx: number, cy: number, ring: number): number {
  if (ring === 0) return 0;
  const ang = (Math.atan2(cy - 256, cx - 256) * (180 / Math.PI) + 450) % 360;
  return ring === 1 ? 0.24 + (ang / 360) * 0.42 : 0.52 + (ang / 360) * 0.55;
}
